import { render, staticRenderFns } from "./NonreactiveCheck.vue?vue&type=template&id=200151fe&scoped=true&"
import script from "./NonreactiveCheck.vue?vue&type=script&lang=js&"
export * from "./NonreactiveCheck.vue?vue&type=script&lang=js&"
import style0 from "./NonreactiveCheck.vue?vue&type=style&index=0&id=200151fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200151fe",
  null
  
)

export default component.exports